import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import "../../styles/Sidebar.css";
import { FaCircle, FaHome, FaUser, FaCog, FaBars, FaTasks, FaAdn, FaStripeS, FaRegCopyright, FaRegCopy, FaLaptop, FaLayerGroup, FaLandmark, FaHourglassStart, FaSignOutAlt, FaAngleDown, FaAngleUp, FaEnvelopeOpenText,FaDatabase, FaArrowRight, FaArrowDown } from 'react-icons/fa';
import { BiDoorOpen } from 'react-icons/bi';
import { TbSettingsCog } from "react-icons/tb";
import { LiaFileArchive } from "react-icons/lia";
import { MdDashboard } from "react-icons/md";
import { Collapse, Nav } from "react-bootstrap";
import "../../index.css";
import nexapi from "../../services/api";
import { useAppContext } from "../../context/appcontext";
import defaultImage from "../../assets/images/default_user.jpg";
import { useLocation } from "react-router-dom";
import { Description } from "@mui/icons-material";

interface Menu {
  id: string;
  name: string;
  description: string;
  iconName: string;
  redirectURL: string;
  isChildMenu: boolean;
  parentChildMenuMap: Menu[];
}

interface MenuItem {
    id: string;
    name: string;
    description?: string;
    iconName?: string;
    redirectURL?: string;
    isChildMenu: boolean;
    parentChildMenuMap: ChildMenuItem[];
}

interface ChildMenuItem {
    id: string;
    name: string;
    description?: string;
    iconName?: string;
    redirectURL?: string;
    isChildMenu: boolean;
    children?: ChildMenuItem[];
}

const Sidebar = () => {
  const { sidebarCollapsed, setIsCollapsed, authChecked, loggedinuser, showSidebar, setShowSidebar } = useAppContext();
  const [submenuOpen, setSubmenuOpen] = useState<string | null>(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1023);
  const [menus, setMenu] = useState<MenuItem[]>([]);
  const [pettyCashOpen, setPettyCashOpen] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const selectedId = queryParams.get("id");

  const handleResize = () => {
    const contentArea = document.querySelector(".content-area") as HTMLElement | null;

    if (window.innerWidth <= 990) {
      setIsMobile(true);
      setIsCollapsed(true);
      setShowSidebar(false); // Hide sidebar on mobile initially
      if (contentArea) contentArea.style.marginLeft = "0px"; // Small sidebar on mobile
    } else {
      setIsMobile(false);
      setIsCollapsed(false);
      setShowSidebar(true); // Show sidebar on desktop
      if (contentArea) contentArea.style.marginLeft = "270px"; // Default expanded sidebar
    }
  };

  const iconMap: { [key: string]: React.ComponentType<any> } = {
    FaHome: FaHome,
    FaTasks: FaTasks,
    FaUser: FaUser,
    FaCog: FaCog,
    FaCircle: FaCircle,
    FaBars: FaBars,
    FaAdn: FaAdn,
    MdDashboard: MdDashboard,
    LiaFileArchive: LiaFileArchive,
    TbSettingsCog: TbSettingsCog,
    BiDoorOpen : BiDoorOpen,
    FaEnvelopeOpenText: FaEnvelopeOpenText,
    FaStripeS: FaStripeS,
    FaRegCopyright: FaRegCopyright,
    FaRegCopy: FaRegCopy,
    FaLaptop: FaLaptop,
    FaLayerGroup: FaLayerGroup,
    FaLandmark: FaLandmark,
    FaHourglassStart: FaHourglassStart,
    FaSignOutAlt: FaSignOutAlt,
  };
  

useEffect(() => {
  const handleResize = () => {
    const contentArea = document.querySelector(".content-area") as HTMLElement | null;

    if (window.innerWidth <= 990) {
      setIsMobile(true);
      setIsCollapsed(true);
      setShowSidebar(false); // Hide sidebar on mobile initially
      if (contentArea) contentArea.style.marginLeft = "0px";
    } else {
      setIsMobile(false);
      setIsCollapsed(false);
      setShowSidebar(true); // Show sidebar on desktop
      if (contentArea) contentArea.style.marginLeft = "270px";
    }
  };

  window.addEventListener("resize", handleResize);
  handleResize(); // Call on mount to set initial state

  return () => window.removeEventListener("resize", handleResize);
}, []);

  const hasFetchedMenu = useRef(false);
  useEffect(() => {
    if (!hasFetchedMenu.current && loggedinuser?.id) {
      getMenu();
      hasFetchedMenu.current = true;
    }
  }, [loggedinuser?.id]);

  const getMenu = async (): Promise<MenuItem[]> => {
    try {
        const response = await nexapi.post(`role/GetMenusForUser?userId=${loggedinuser.id}`);

        if (response.status !== 200 || !response.data?.data) {
            console.error("Invalid response structure:", response);
            return [];
        }

        const data: MenuItem[] = response.data.data;

        // Process the menus to add Petty Cash submenus if needed
        const processedMenus = data.map(menu => {
            const processedMenu: MenuItem = {
                ...menu,
                parentChildMenuMap: menu.parentChildMenuMap?.map(child => {
                    const isPettyCash = child.description?.includes("Petty Cash")
                    const processedChild: ChildMenuItem = {
                        ...child,
                        children: isPettyCash
                            ? [{
                                id: `${child.id}`,
                                name: child.name,
                                redirectURL: child.redirectURL,
                                isChildMenu: true,
                                iconName: "FaCircle"
                            }]
                            : undefined
                    };
                    return processedChild;
                }) ?? []
            };
            return processedMenu;
        });
        
        setMenu(processedMenus);
        return processedMenus;
    } catch (error) {
        console.error("Error fetching Menu: ", error);
        return [];
    }
};

  return (
    authChecked && (
      <div
        style={{ borderRight: '1px solid ##1f5186', color: 'blue', backgroundColor: '#1f5186' }}
        className={`d-flex flex-column text-light vh-100 sidebar 
          ${isMobile ? (showSidebar ? 'mobile-visible' : 'mobile-hidden') : ''} 
          ${!isMobile && (sidebarCollapsed ? 'sidebar-collapsed' : 'sidebar-expanded')}`}
      >
       
          <div 
          className={`user-profile
            ${isMobile ? (showSidebar ? 'displayprofile' : '') : ''} 
            ${!isMobile && (sidebarCollapsed ? 'hideprofile' : 'displayprofile')}`
          } 
          id="UserProfile">
          <div className="row" style={{ position: 'relative' }}>
            <div className="col-6 col-lg-4 pr-0">
              <figure>
                <img
                  id="Profile"
                  src={loggedinuser?.profileImage ?? defaultImage}
                  className="img-fluid profile-picture"
                  data-themekey="#"
                />
              </figure>
            </div>
            <div className="col-6 col-lg-8 pl-0">
              <h5 id="profile-name">{loggedinuser?.displayName}</h5>
              <span id="user-type">{loggedinuser?.roles}</span>
            </div>
          </div>
        </div>
        
  
      <ul className="nav scroll">
        {menus.map((menu) => {
          const IconComponent = iconMap[menu.iconName] || FaCircle;
          
          return (
            <li
              className={`nav-item  
    ${menu.parentChildMenuMap?.length > 0 ? 'has-submenu' : ''} 
    ${menu.name?.toLowerCase().includes('archive') ? 'archive-menu' : ''}
  `}
              key={menu.id}
            >
              {menu.parentChildMenuMap?.length > 0 ? (
                <>
                  <Nav.Link
                    className="nav-link text-light"
                    href="#"
                    onClick={() => {
                      if (!sidebarCollapsed) {
                        setSubmenuOpen(submenuOpen === menu.id ? null : menu.id);
                      }
                      if (isMobile) setShowSidebar(false);
                    }}
                    aria-controls={`submenu-${menu.id}`}
                    aria-expanded={submenuOpen === menu.id}
                  >
                    {menu.iconName && <IconComponent size={20} className="me-2" />}
                    <span className={`menu-label mt-1 ${sidebarCollapsed ? 'collapsed' : ''}`}>
                      {menu.name}
                    </span>
                    {!sidebarCollapsed && menu.parentChildMenuMap?.length > 0 && (
                      submenuOpen === menu.id ? (
                        <FaArrowDown size={15} className="right" />
                      ) : (
                        <FaArrowRight size={15} className="right" />
                      )
                    )}
                  </Nav.Link>

                  {/* Submenu - collapsed or expanded */}
                  {sidebarCollapsed ? (
                    <div id={`submenu-${menu.id}`} className="submenu-container">
                      <Nav className="flex-column">
                      {(() => {
                          const childMenusWithChildren = menu.parentChildMenuMap?.filter(c => c.children?.length > 0) || [];
                          const childMenusWithoutChildren = menu.parentChildMenuMap?.filter(c => !c.children || c.children.length === 0) || [];

                          return (
                            <>
                              {/* Render regular child menus */}
                              {childMenusWithoutChildren.map((childMenu) => (
                                <NavLink
                                  key={childMenu.id}
                                  to={`/${childMenu.redirectURL}`}
                                  className={`nav-link text-light pettyCash hieght35`} 
                                  
                                  onClick={() => {
                                    if (isMobile) setShowSidebar(false);
                                  }}
                                >
                                  <FaCircle size={8} className="me-2" />
                                  <span className="submenu-label">{childMenu.name}</span>
                                </NavLink>
                              ))}

                              {/* Render all childMenu.children grouped into a single submenu */}
                              {childMenusWithChildren.length > 0 && (
                                <>
                                  <div className="nav-link text-light fw-bold mt-2">Petty Cash</div>
                                  <div className="sub-submenu-container ps-4">
                                    <Nav className="flex-column">
                                      {childMenusWithChildren.flatMap((childMenu) =>
                                        childMenu.children.map((subChild) => (
                                          <NavLink
                                            key={subChild.id}
                                            to={`/${subChild.redirectURL}`}
                                            className="nav-link text-light pettyCash hieght35"
                                            onClick={(e) => {
    if (e.ctrlKey || e.metaKey || e.button === 1) return;
    if (isMobile) setShowSidebar(false);
  }}
                                          >
                                            <FaCircle size={6} className="me-2" />
                                            <span className="submenu-label">{subChild.name}</span>
                                          </NavLink>
                                        ))
                                      )}
                                    </Nav>
                                  </div>
                                </>
                              )}
                            </>
                          );
                        })()}

                      </Nav>
                    </div>
                  ) : (
                    <Collapse in={submenuOpen === menu.id}>
                      <div id={`submenu-${menu.id}`} className="submenu-container">
                        <Nav className="flex-column ps-3">
                        {(() => {
                            const childMenusWithChildren = menu.parentChildMenuMap?.filter(c => c.children?.length > 0) || [];
                            const childMenusWithoutChildren = menu.parentChildMenuMap?.filter(c => !c.children || c.children.length === 0) || [];

                            return (
                              <>
                                {/* Render regular child menus */}
                                {childMenusWithoutChildren.map((childMenu) => (
                                  <NavLink
                                    key={childMenu.id}
                                    to={`/${childMenu.redirectURL}`}
                                    className={`nav-link text-light hieght35   ${childMenu.name === selectedId || menu.name === "Settings"  ? "" : "activeLink"}`}
                                    onClick={() => {
                                      if (isMobile) setShowSidebar(false);
                                    }}
                                  >
                                    <FaCircle size={8} className="me-2" />
                                    <span className="submenu-label">{childMenu.name}</span>
                                  </NavLink>
                                ))}

                                {/* Render all childMenu.children grouped into a single submenu */}
                               {childMenusWithChildren.length > 0 && (
                                <>
                                  <Nav.Link
                                    className="nav-link pettyCash text-light"
                                    href="#"
                                    onClick={() => {
                                      setPettyCashOpen(!pettyCashOpen);
                                      if (isMobile) setShowSidebar(false);
                                    }}
                                    aria-controls="submenu-petty-cash"
                                    aria-expanded={pettyCashOpen}
                                  >
                                    <FaCircle size={8} className="me-2" />
                                    <span className="menu-label mt-1">Petty Cash</span>
                                    {pettyCashOpen ? (
                                      <FaAngleUp size={20} className="me-2" />
                                    ) : (
                                      <FaAngleDown size={20} className="me-2" />
                                    )}
                                  </Nav.Link>

                                  <Collapse in={pettyCashOpen}>
                                    <div id="submenu-petty-cash" className="sub-submenu-container ps-4">
                                      <Nav className="flex-column">
                                        {childMenusWithChildren.flatMap((childMenu) =>
                                          childMenu.children.map((subChild) => (
                                            <NavLink
                                              key={subChild.id}
                                              to={`/${subChild.redirectURL}`}
                                              className="nav-link text-light hieght35"
                                              onClick={() => {
                                                if (isMobile) setShowSidebar(false);
                                              }}
                                            >
                                              <FaCircle size={6} className="me-2" />
                                              <span className="submenu-label">{subChild.name}</span>
                                            </NavLink>
                                          ))
                                        )}
                                      </Nav>
                                    </div>
                                  </Collapse>
                                </>
                              )}

                              </>
                            );
                          })()}

                        </Nav>
                      </div>
                    </Collapse>
                  )}
                </>
              ) : (
               <NavLink
  to={`/${menu.redirectURL}`}
  className="nav-link text-light hieght35 align-items-center"
  onClick={(e) => {
    // Allow Ctrl+Click / middle click / Cmd+Click
    if (e.ctrlKey || e.metaKey || e.button === 1) return;

    // Normal click behavior
    if (isMobile) setShowSidebar(false);
  }}
>
  {menu.iconName && <IconComponent size={20} className="me-2" />}
  <span className={`menu-label mt-1 ${sidebarCollapsed ? 'collapsed' : ''}`}>
    {menu.name}
  </span>
  {!sidebarCollapsed && <FaArrowRight size={15} className="right" />}
</NavLink>
              )}
            </li>
          );
        })}
      </ul>
      </div>
    )
  );
  
};

export default Sidebar;
